export default "skymp5-front/009d76f5680edc1030bbd64a5f6819b9.png";